module.exports = __webpack_public_path__ + "img/Type_Steel.6eeb53cf.png";